import { openProSearch } from './proSearch';

/**
 * Duplicate-pro helpers for the Pending EDI Orders drill-down.
 *
 * The backend's per-edihandle dupe query returns `dupeprolist` and — for the default
 * (BOL/booking) branch — also `dupeprolist2` (booking-matched dupes for non-import
 * moves). The two are complementary, so the "dupe pros" for a row is the union of both.
 */

/** Parse a GROUP_CONCAT list ("101,102,103") into trimmed, non-empty pro strings. */
const parseList = (v: unknown): string[] =>
  v ? String(v).split(',').map((s) => s.trim()).filter(Boolean) : [];

/** Union of dupeprolist + dupeprolist2 (deduped, order preserved). */
export function combineDupePros(dupeprolist?: unknown, dupeprolist2?: unknown): string[] {
  return [...new Set([...parseList(dupeprolist), ...parseList(dupeprolist2)])];
}

/**
 * Open a new tab of search results for the given pro numbers (multi-term search).
 *
 * Thin alias for `openProSearch`, which is where this lives now: the same call is used
 * for pros that have nothing to do with duplicates (a bucket drill row, an attach
 * candidate), so the name stopped describing it. Kept so the dupe call sites still read
 * as what they are.
 */
export const openDupeProSearch = (pros: string[]): void => openProSearch(pros);
